import React from "react";
import { ModeRendererProps } from "./types";

export function FingerprintMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      <ellipse rx="280" ry="340" fill="url(#fpDepth)" />
      {Array.from({ length: 18 }).map((_, i) => (
        <ellipse
          key={i}
          rx={20 + i * 12}
          ry={28 + i * 16}
          fill="none"
          stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
          strokeWidth="2"
          opacity={0.65 - i * 0.03}
          transform="rotate(-12)"
        />
      ))}
      <circle r="4" fill={brand.white} />
    </g>
  );
}
